import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { ISexOffender, ISexOffenderCheckin } from '@/models';

import { http } from './http';
import { IGetParams, IIndeterminatePaginationResponse } from './types';

export interface IOverdueSexOffender {
  _id: string;
  sexOffenderId: string;
  riskLevel: number;
  nextDueDate?: string;
  personName: string;
  daysOverdue: number;
}

export interface ISexOffenderSettings {
  checkinFrequency: number;
}

export interface IOverdueSexOffenderResponse {
  notifications: IOverdueSexOffender[];
  settings: ISexOffenderSettings;
}

export const SexOffenderApi = {
  getOverdue: (): Promise<AxiosResponse<IOverdueSexOffenderResponse>> => {
    return http.get(`api/${ApiVersion.V1}/sex-offenders/overdue`);
  },

  list: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IIndeterminatePaginationResponse<ISexOffender>>> => {
    return http.get(`api/${ApiVersion.V1}/sex-offenders`, { params });
  },

  create: (
    data: Partial<ISexOffender>,
  ): Promise<AxiosResponse<ISexOffender>> => {
    return http.post(`api/${ApiVersion.V1}/sex-offenders`, data);
  },

  getById: (
    id: string,
  ): Promise<
    AxiosResponse<ISexOffender & { checkins: ISexOffenderCheckin[] }>
  > => {
    return http.get(`api/${ApiVersion.V1}/sex-offenders/${id}`);
  },

  update: (
    id: string,
    data: Partial<ISexOffender>,
  ): Promise<AxiosResponse<ISexOffender>> => {
    return http.put(`api/${ApiVersion.V1}/sex-offenders/${id}`, data);
  },

  getByPersonId: (personId: string): Promise<AxiosResponse<ISexOffender>> => {
    return http.get(`api/${ApiVersion.V1}/sex-offenders/by-person/${personId}`);
  },

  addCheckin: (
    offenderId: string,
    data: Partial<ISexOffenderCheckin>,
  ): Promise<AxiosResponse<ISexOffenderCheckin>> => {
    return http.post(
      `api/${ApiVersion.V1}/sex-offenders/${offenderId}/checkins`,
      data,
    );
  },

  updateCheckin: (
    offenderId: string,
    checkinId: string,
    data: Partial<ISexOffenderCheckin>,
  ): Promise<AxiosResponse<ISexOffenderCheckin>> => {
    return http.put(
      `api/${ApiVersion.V1}/sex-offenders/${offenderId}/checkins/${checkinId}`,
      data,
    );
  },

  deleteCheckin: (
    offenderId: string,
    checkinId: string,
  ): Promise<AxiosResponse<void>> => {
    return http.delete(
      `api/${ApiVersion.V1}/sex-offenders/${offenderId}/checkins/${checkinId}`,
    );
  },
};
